import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { IonIcon } from '@ionic/react';
import { Card, Tab, Tabs } from 'react-bootstrap';
import { calendarOutline, sendOutline, timeOutline, trashOutline } from 'ionicons/icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import VnButton from '@ui/components/VnButton';
import moment from 'moment';
import { formatDMY, getCurrentISOformatDMY, handleRolePermission } from '@infrastructure/helpers';
import { getAllProgressNotesByWorkOrderIdAsync, deleteProgressNotesByIdAsync, createProgressNotesByIdAsync, updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { addErrorNotification } from '@application/features/common/notificationSlice';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { VisserModule } from '@application/common/enums/visser-module';
const GeneralCard = ({ disableWorkOrder, formData, onCardFieldChange, onCardCalenderChange, onCardToggleButtonChange, onCardTimeCalenderChange = () => { }, onFieldChangeWithoutLockModule }) => {
    const dispatch = useAppDispatch();
    const { currentUser } = useAppSelector((state) => state.auth);
    const [spotDate, setSpotDate] = useState(null);
    const [spotDatePickerOpen, setSpotDateIsOpen] = useState(false);
    const [selectedTime, setSelectedTime] = useState(null);
    const [openTimePicker, setTimepickerIsOpen] = useState(false);
    const [addedProgressNote, setAddedProgressNote] = useState('');
    const [currentUserLastProgreeNoteId, setCurrentUserLastProgreeNoteId] = useState(0);
    const [isProgressNoteDisabled, setIsProgressNoteDisabled] = useState(false);
    const [activeTab, setActiveTab] = useState('NotesTab');
    const [descriptionChanged, setDescriptionChanged] = useState(false);
    const [terplaatsFieldChange, setTerplaatsFieldChange] = useState(false);
    const [progressNotesList, setProgressNotesListd] = useState([]);
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
        if (tabKey == 'TerplaatsTab') {
            setDescriptionChanged(true);
        }
    };
    const openLocationDatePicker = () => {
        setSpotDateIsOpen(!spotDatePickerOpen);
    };
    const handleLocationDateChange = (date) => {
        setSpotDate(date ? moment(date).toDate() : null);
        setSpotDateIsOpen(false);
        onCardCalenderChange('tpDate', date);
    };
    const handleTimepickerChange = () => {
        setTimepickerIsOpen(!openTimePicker);
    };
    const handleTimeChange = (timeInMinutes) => {
        setSelectedTime(timeInMinutes);
        onCardTimeCalenderChange('tpTiming', timeInMinutes);
    };
    const handleProgressNoteInputChange = (event) => {
        setAddedProgressNote(event.target.value);
    };
    const handelProgressNoteDeleteClick = (noteid) => {
        if (formData?.id > 0 && noteid > 0 && !isProgressNoteDisabled) {
            setIsProgressNoteDisabled(true);
            dispatch(deleteProgressNotesByIdAsync({
                id: noteid,
                workOrderId: formData?.id,
                note: ''
            }))
                .unwrap()
                .then((res) => {
                if (formData?.id > 0) {
                    getAllProgressNotes(formData?.id);
                }
            });
        }
    };
    const handleProgressNoteButtonClick = async () => {
        if (addedProgressNote.trim() && formData?.id > 0 && !isProgressNoteDisabled) {
            setIsProgressNoteDisabled(true);
            var moduleLockStatus = await checkModulelock();
            if (moduleLockStatus == false) {
                dispatch(createProgressNotesByIdAsync({
                    workOrderId: formData?.id,
                    note: addedProgressNote
                }))
                    .unwrap()
                    .then((res) => {
                    setAddedProgressNote('');
                    if (formData?.id > 0) {
                        getAllProgressNotes(formData?.id);
                    }
                });
            }
        }
    };
    useEffect(() => {
        setSpotDate(formData.tpDate ? moment(formData.tpDate).toDate() : null);
        if (formData?.id > 0) {
            getAllProgressNotes(formData?.id);
        }
        else {
            setIsProgressNoteDisabled(true);
        }
    }, [dispatch, formData.id, formData.tpDate]);
    const getAllProgressNotes = (workOrderId) => {
        dispatch(getAllProgressNotesByWorkOrderIdAsync(workOrderId)).then((res) => {
            if (res?.payload && Array.isArray(res.payload)) {
                const lastNoteIdForCurrentUser = res.payload
                    .filter((note) => currentUser &&
                    currentUser.createdBy === note.createdBy &&
                    note.created &&
                    formatDMY(note.created?.toString()) === getCurrentISOformatDMY())
                    .map((note) => note.id)
                    .pop();
                setCurrentUserLastProgreeNoteId(lastNoteIdForCurrentUser ?? 0);
                setProgressNotesListd(res.payload);
            }
            else {
                setCurrentUserLastProgreeNoteId(0);
            }
            scrollProgressNoteToBottom();
            setIsProgressNoteDisabled(false);
        });
    };
    const progressNotesRef = useRef(null);
    const scrollProgressNoteToBottom = () => {
        const container = progressNotesRef.current;
        if (container && container.scrollHeight > 0) {
            container.scrollTo({
                top: container.scrollHeight,
                behavior: 'smooth'
            });
        }
    };
    const onWerkbonCancelClicked = () => {
        setActiveTab('NotesTab');
        setDescriptionChanged(false);
    };
    const werkbonhandleConfirm = () => {
        setDescriptionChanged(false);
    };
    useEffect(() => {
        if (formData.id) {
            if (formData.tpDate && terplaatsFieldChange) {
                onFieldChangeWithoutLockModule('workOrderFormData', '');
            }
            if (formData.tpLocation && terplaatsFieldChange) {
                onFieldChangeWithoutLockModule('workOrderFormData', '');
            }
            if (formData.tpMechanic && terplaatsFieldChange) {
                onFieldChangeWithoutLockModule('workOrderFormData', '');
            }
            if (formData.tpSameAsClientVisitAddress && terplaatsFieldChange) {
                onFieldChangeWithoutLockModule('workOrderFormData', '');
            }
            if (formData.tpTiming && terplaatsFieldChange) {
                onFieldChangeWithoutLockModule('workOrderFormData', '');
            }
        }
    }, [formData.id, formData.tpDate, formData.tpLocation, formData.tpMechanic, formData.tpSameAsClientVisitAddress, formData.tpTiming]);
    useEffect(() => {
        if (formData.workOrderFormData == null || formData.workOrderFormData == '') {
            setDescriptionChanged(false);
        }
    }, [formData.id]);
    //-----------------------Module Lock -------------------------------------------
    const checkModulelock = async () => {
        if (formData.id) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Werkorder,
                recordId: formData.id
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData))
                    .unwrap()
                    .then();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                else {
                    dispatch(unsetModuleLock());
                    // setIsPersistantInfoCustomToasterOpen(false);
                    return false;
                }
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    return (_jsxs(_Fragment, { children: [_jsx(Card, { className: 'vn-General-Tab-Card vn-Card-Component', children: _jsx(Card.Body, { className: 'd-flex flex-column mt-2 vn-GeneralTab-cardbody', children: _jsxs(Tabs, { activeKey: activeTab, onSelect: handleTabChange, className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'NotesTab', title: 'Voortgang notities', children: _jsxs("div", { className: 'd-flex flex-column', children: [_jsxs("div", { ref: progressNotesRef, className: 'vn-GeneralTab-chat-Card-contaner', children: [progressNotesList &&
                                                    progressNotesList.map((note, index) => (_jsx(Card, { className: 'vn-GeneralTab-Card', children: _jsxs(Card.Body, { children: [_jsxs("div", { className: 'vn-Card-design', children: [_jsxs("div", { children: [_jsx("img", { src: 'images/user.png', alt: 'app-user', className: 'vn-Card-Image' }), _jsxs("p", { className: 'vn-Card-Text', children: [note.createdByFirstName, " ", note.createdByLastName] })] }), _jsx("div", { className: 'vn-Card-Span', children: _jsxs("span", { className: 'vn-General-Tab-Span', children: [_jsxs("span", { children: [" ", formatDMY(note.created?.toString())] }), currentUserLastProgreeNoteId === note.id ? (_jsx("span", { onClick: async () => {
                                                                                            var moduleLockStatus = await checkModulelock();
                                                                                            if (moduleLockStatus == false) {
                                                                                                if (handleRolePermission(Permission.BESTELLINGEN, PermissionType.Update) &&
                                                                                                    !disableWorkOrder) {
                                                                                                    handelProgressNoteDeleteClick(note.id);
                                                                                                }
                                                                                                else {
                                                                                                    dispatch(addErrorNotification('Toegang Geweigerd'));
                                                                                                }
                                                                                            }
                                                                                        }, children: _jsx(IonIcon, { className: 'vn-progress-note-delete', icon: trashOutline }) })) : null] }) })] }), _jsx(Card.Text, { className: 'vn-Card-Message', children: note.note })] }) }, index))), _jsx("div", {})] }), _jsxs("div", { className: 'input-group vn-GeneralTab-chat-input-group ml-14', children: [_jsx("input", { type: 'text', className: 'form-control vn-GeneralTab-chat-input-field', placeholder: 'Typ hier', "aria-label": "Recipient's username with two button addons", "aria-describedby": 'button-addon4', onChange: handleProgressNoteInputChange, value: addedProgressNote, onKeyDown: (event) => {
                                                        if (event.key === 'Enter') {
                                                            event.preventDefault();
                                                            if (handleRolePermission(Permission.WERKORDER, PermissionType.Update) &&
                                                                !disableWorkOrder) {
                                                                handleProgressNoteButtonClick();
                                                            }
                                                            else {
                                                                dispatch(addErrorNotification('Toegang Geweigerd'));
                                                            }
                                                        }
                                                    } }), _jsx("div", { className: 'input-group-append', id: 'button-addon4', children: _jsx(VnButton, { type: 'button', customClassName: 'vn-search-button', mode: 'primary', size: 'sm', icon: sendOutline, onClick: () => {
                                                            if (handleRolePermission(Permission.WERKORDER, PermissionType.Update)) {
                                                                handleProgressNoteButtonClick();
                                                            }
                                                            else {
                                                                dispatch(addErrorNotification('Toegang Geweigerd'));
                                                            }
                                                        }, isDisabled: !isProgressNoteDisabled && disableWorkOrder }) })] })] }) }), _jsx(Tab, { eventKey: 'TerplaatsTab', title: 'Terplaats', children: _jsxs("div", { className: 'ml-14 mr-14', children: [_jsx("div", { className: 'row mt-4', children: _jsx("div", { className: 'col-md-12', children: _jsxs("div", { className: 'form-check', children: [_jsx("input", { type: 'checkbox', className: 'form-check-input', id: 'remember-check', checked: formData.tpSameAsClientVisitAddress, onChange: (e) => {
                                                                setTerplaatsFieldChange(true);
                                                                onCardToggleButtonChange('tpSameAsClientVisitAddress', e.target.checked);
                                                            } }), _jsx("label", { htmlFor: 'remember-check', className: 'vn-RadioButton-Text', children: "Gelijk aan bezoekadres" })] }) }) }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'col-md-12', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Locatie" }), _jsx("textarea", { className: 'form-control vn-Input', style: { maxHeight: '140px' }, id: 'generalTabCardTextArea', rows: 5, value: formData.tpLocation, onChange: (e) => {
                                                            setTerplaatsFieldChange(true);
                                                            onCardFieldChange('tpLocation', e.target.value);
                                                        } })] }) }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'col-md-8', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Datum" }), _jsxs("div", { className: 'input-group', children: [_jsx(DatePicker, { selected: spotDate, onInputClick: openLocationDatePicker, className: 'vn-GeneralTab-Datepicker', open: spotDatePickerOpen, onClickOutside: openLocationDatePicker, onChange: (date) => {
                                                                    setTerplaatsFieldChange(true);
                                                                    handleLocationDateChange(date);
                                                                }, dateFormat: 'dd-MM-yyyy', placeholderText: 'Selecteer Datum', value: formatDMY(spotDate?.toString()), onCalendarClose: () => setSpotDateIsOpen(false), onKeyDown: (e) => {
                                                                    if (e.key === 'Backspace') {
                                                                        handleLocationDateChange(null);
                                                                    }
                                                                } }), _jsx("div", { className: 'input-group-append', children: _jsx(IonIcon, { icon: calendarOutline, className: 'vn-Datepicker-Icon', onClick: openLocationDatePicker }) })] })] }) }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'col-md-8', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Tijd" }), _jsxs("div", { className: 'input-group', children: [_jsx(DatePicker, { selected: selectedTime, onChange: (time) => {
                                                                    setTerplaatsFieldChange(true);
                                                                    handleTimeChange(time);
                                                                }, showTimeSelect: true, className: 'vn-GeneralTab-Datepicker', onInputClick: handleTimepickerChange, onClickOutside: handleTimepickerChange, showTimeSelectOnly: true, timeCaption: 'Time', dateFormat: 'h:mm aa', open: openTimePicker, placeholderText: 'Selecteer tijd', onCalendarClose: () => setTimepickerIsOpen(false), value: formData.tpTiming, readOnly: true, onKeyDown: (e) => {
                                                                    if (e.key === 'Backspace') {
                                                                        handleTimeChange(null);
                                                                    }
                                                                } }), _jsx("div", { className: 'input-group-append', children: _jsx(IonIcon, { icon: timeOutline, className: 'vn-Datepicker-Icon', onClick: handleTimepickerChange }) })] })] }) }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'col-md-8', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Monteur(s)" }), _jsx("input", { id: 'tpMechanic', type: 'text', value: formData.tpMechanic, placeholder: 'Voer monteur in', className: 'form-control vn-Date-Input', onChange: (e) => {
                                                            setTerplaatsFieldChange(true);
                                                            onCardFieldChange('tpMechanic', e.target.value);
                                                        } })] }) })] }) })] }) }) }), formData.workOrderFormData && descriptionChanged == true && (_jsx(VnConfirmationModel, { title: 'Deze actie zal de werkbon wijzigen.', onCancel: () => onWerkbonCancelClicked(), onConfirm: () => werkbonhandleConfirm(), onOpen: descriptionChanged }))] }));
};
export default GeneralCard;
